import { configs } from "_config/index";

export const forceLogoutUrlArray = [
	`${ configs.AUTH }auth/refresh`,
	`${ configs.AUTH }auth/exchangeToken`,
	`${ configs.AUTH }auth/login`,
	`${ configs.AUTH }auth/loginViaGoogle`
];